import { AGE_GROUPS, EVENT_STATUS, EVENT_TIMEFRAMES } from "utils/helpers/enums/shared.enum";
import { FilterDTO } from "../shared/filter.dto";

export class EventsFilterDTO extends FilterDTO {
    searchTitle: string = '';
    ageGroups: AGE_GROUPS;
    status: EVENT_STATUS;
    timeFrame: EVENT_TIMEFRAMES.ALL;
    isSession: string = '';
    hostId: number;
    childId: number;

    constructor(data: Partial<EventsFilterDTO> = {}) {
        super();
        for (let key in data) {
            this[key] = data[key];
        }
    }
}

export class HostEventsFilterDTO extends FilterDTO {
    searchTitle: string = '';
    ageGroups: AGE_GROUPS;
    status: EVENT_STATUS;
    timeFrame: EVENT_TIMEFRAMES.UPCOMING;
    isSession: string = '';
    hostId: number;
    childId: number;

    constructor(data: Partial<HostEventsFilterDTO> = {}) {
        super();
        for (let key in data) {
            this[key] = data[key];
        }
    }
}

export class AttendeeEventsFilterDTO extends FilterDTO {
    searchTitle: string = '';
    ageGroups: AGE_GROUPS;
    status: EVENT_STATUS;
    timeFrame: EVENT_TIMEFRAMES.ALL;
    isSession: string = '';
    hostId: number;
    childId: number;

    constructor(data: Partial<AttendeeEventsFilterDTO> = {}) {
        super();
        for (let key in data) {
            this[key] = data[key];
        }
    }
}